import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { motion } from "framer-motion";
import { type TemplateEntry } from "../../../data/template-registry";
import { complexityColors } from "./template-utils";

interface TemplateHeroProps {
  template: TemplateEntry;
}

export const TemplateHero: React.FC<TemplateHeroProps> = ({ template }) => {
  const { name, description, complexity, language, systemType, tags } =
    template;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box sx={{ mb: 6 }}>
        <Typography variant="h2" component="h1" gutterBottom fontWeight={800}>
          {name}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>

        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
          <Chip
            label={`Complexity: ${complexity}`}
            color={complexityColors[complexity]}
            size="small"
          />
          <Chip label={language} variant="outlined" size="small" />
          <Chip
            label={systemType.replace(/_/g, " ")}
            variant="outlined"
            size="small"
          />
          {tags.map((tag) => (
            <Chip key={tag} label={tag} variant="outlined" size="small" />
          ))}
        </Box>
      </Box>
    </motion.div>
  );
};
